import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { PlatformThemeProvider } from '@/components/providers/PlatformThemeProvider';
import { SessionQueryProvider } from '@/components/providers/SessionQueryProvider';
import { ConfirmDialogProvider } from '@/components/ui/confirm-dialog';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { CortinaDeAula } from '@/components/ui/CortinaDeAula';
import { EntradaDoCadeado } from '@/components/auth/EntradaDoCadeado';
import './styles/globals.css';

// Auto-reload on chunk load failure (happens after deploy with new hashes)
window.addEventListener('error', (e) => {
  if (
    e.message?.includes('Failed to fetch dynamically imported module') ||
    e.message?.includes('Loading chunk') ||
    e.message?.includes('Loading CSS chunk')
  ) {
    const reloaded = sessionStorage.getItem('chunk-reload');
    if (!reloaded) {
      sessionStorage.setItem('chunk-reload', '1');
      window.location.reload();
    }
  }
});
window.addEventListener('unhandledrejection', (e) => {
  if (
    e.reason?.message?.includes('Failed to fetch dynamically imported module')
  ) {
    const reloaded = sessionStorage.getItem('chunk-reload');
    if (!reloaded) {
      sessionStorage.setItem('chunk-reload', '1');
      window.location.reload();
    }
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PlatformThemeProvider>
      {/* Navegar espera a página nova com a atual na tela (sem o carregador
          tomar tudo na primeira visita de cada página). */}
      <BrowserRouter future={{ v7_startTransition: true }}>
        <SessionQueryProvider>
          <ConfirmDialogProvider>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </ConfirmDialogProvider>
        </SessionQueryProvider>
        {/* Cortina da aula e entrada do login ficam fora do SessionQueryProvider:
            ele remonta a árvore quando a identidade muda (login), e as duas
            animações precisam sobreviver a essa troca. */}
        <CortinaDeAula />
        <EntradaDoCadeado />
      </BrowserRouter>
    </PlatformThemeProvider>
  </React.StrictMode>,
);
